import React, { useEffect, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL || "/api";

const QuickItemModal = ({ isOpen, onClose, type = "actions", hotelId, token, initial = null, onSuccess }) => {
  const [titleFr, setTitleFr] = useState("");
  const [descriptionFr, setDescriptionFr] = useState("");
  const [titleBFr, setTitleBFr] = useState("");
  const [subtitleFr, setSubtitleFr] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [descriptionEn, setDescriptionEn] = useState("");
  const [titleBEn, setTitleBEn] = useState("");
  const [subtitleEn, setSubtitleEn] = useState("");
  const [titleAr, setTitleAr] = useState("");
  const [descriptionAr, setDescriptionAr] = useState("");
  const [titleBAr, setTitleBAr] = useState("");
  const [subtitleAr, setSubtitleAr] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [iconUrl, setIconUrl] = useState("");
  const [gmValue, setGmValue] = useState("");
  const [itemType, setItemType] = useState("");
  const [waterVolume, setWaterVolume] = useState("");
  const isEdit = Boolean(initial);

  const isActionType = (item) => {
    return item && (item.acId || item.actId || item.acType);
  };

  useEffect(() => {
    if (initial) {
      // Déduire les bons champs selon action/récompense
      const inferredTitle = initial.titleFr || initial.display_name || initial.acTitle || initial.rwName || initial.name || "";
      const inferredDescription = initial.descriptionFr || initial.description || "";
      const inferredImage = initial.imageUrl || initial.acPictureURL || initial.rwPictureURL || initial.picture || initial.pictureURL || "";
      const inferredIcon = initial.iconUrl || initial.acIconURL || initial.actIconURL || initial.rwIconURL || "";

      setTitleFr(inferredTitle);
      setDescriptionFr(inferredDescription);
      setTitleBFr(initial.titleBFr || "");
      setSubtitleFr(initial.subtitleFr || "");
      setTitleEn(initial.titleEn || "");
      setDescriptionEn(initial.descriptionEn || "");
      setTitleBEn(initial.titleBEn || "");
      setSubtitleEn(initial.subtitleEn || "");
      setTitleAr(initial.titleAr || "");
      setDescriptionAr(initial.descriptionAr || "");
      setTitleBAr(initial.titleBAr || "");
      setSubtitleAr(initial.subtitleAr || "");
      setImageUrl(inferredImage);
      setIconUrl(inferredIcon);
      setGmValue(isActionType(initial) ? initial.acReward ?? initial.acGreenMile ?? initial.actReward ?? "" : initial.rwCost ?? "");
      setItemType(isActionType(initial) ? initial.acType || initial.actType || "CLAIM" : initial.rwType || "CODE");
      setWaterVolume(initial.rwWaterVolume ?? "");
    } else {
      setTitleFr("");
      setDescriptionFr("");
      setTitleBFr("");
      setSubtitleFr("");
      setImageUrl("");
      setIconUrl("");
      setTitleEn("");
      setDescriptionEn("");
      setTitleBEn("");
      setSubtitleEn("");
      setTitleAr("");
      setDescriptionAr("");
      setTitleBAr("");
      setSubtitleAr("");
      setGmValue("");
      setItemType(type === "actions" ? "CLAIM" : "CODE");
      setWaterVolume("");
    }
  }, [initial, isOpen, type]);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const isAction = type === "actions";
      if (isEdit) {
        const id = isAction ? initial.acId || initial.actId : initial.rwId;
        const url = isAction ? `${API_URL}/greenmiles/hotels/${hotelId}/actions/${id}/simple` : `${API_URL}/greenmiles/hotels/${hotelId}/rewards/${id}/simple`;
        await fetch(url, {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(
            isAction
              ? {
                  titleFr,
                  descriptionFr,
                  titleBFr,
                  subtitleFr,
                  titleEn,
                  descriptionEn,
                  titleBEn,
                  subtitleEn,
                  titleAr,
                  descriptionAr,
                  titleBAr,
                  subtitleAr,
                  imageUrl,
                  iconUrl,
                  type: itemType || undefined,
                  rewardPoints: gmValue !== "" ? Number(gmValue) : undefined,
                }
              : {
                  titleFr,
                  descriptionFr,
                  subtitleFr,
                  titleEn,
                  descriptionEn,
                  subtitleEn,
                  titleAr,
                  descriptionAr,
                  subtitleAr,
                  imageUrl,
                  iconUrl,
                  type: itemType || undefined,
                  cost: gmValue !== "" ? Number(gmValue) : undefined,
                  waterVolume: waterVolume !== "" ? Number(waterVolume) : undefined,
                }
          ),
        });
      } else {
        // Création désactivée: on passe exclusivement par les templates
        onClose();
        return;
      }
      if (onSuccess) onSuccess();
      onClose();
    } catch (err) {
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl mx-4">
        <div className="px-5 py-4 border-b border-gray-100 flex items-center justify-between">
          <h3 className="text-lg font-semibold text-gray-900">Modifier {type === "actions" ? "une action" : "une récompense"}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
            ✕
          </button>
        </div>
        <form onSubmit={handleSubmit} className="p-5 max-h-[75vh] overflow-y-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Titre (FR)</label>
            <input value={titleFr} onChange={(e) => setTitleFr(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="Ex: Douche responsable" required />
            </div>
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Titre (EN)</label>
            <input value={titleEn} onChange={(e) => setTitleEn(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="e.g., Responsible shower" />
            </div>
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Titre (AR)</label>
            <input value={titleAr} onChange={(e) => setTitleAr(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="العنوان" />
            </div>
            {type === "actions" && (
              <>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Titre B (FR)</label>
                  <input value={titleBFr} onChange={(e) => setTitleBFr(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="Ex: Économisez l'eau" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Titre B (EN)</label>
                  <input value={titleBEn} onChange={(e) => setTitleBEn(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="e.g., Save water" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Titre B (AR)</label>
                  <input value={titleBAr} onChange={(e) => setTitleBAr(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="العنوان ب" />
                </div>
              </>
            )}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">{type === "actions" ? "GM donnés" : "GM requis"}</label>
              <input type="number" min="0" value={gmValue} onChange={(e) => setGmValue(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Type</label>
              <select value={itemType} onChange={(e) => setItemType(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]">
                {type === "actions" ? (
                  <>
                    <option value="CLAIM">CLAIM</option>
                    <option value="YESNO">YESNO</option>
                    <option value="YESNOSTAY">YESNOSTAY</option>
                    <option value="YESNOMAIL">YESNOMAIL</option>
                    <option value="CUSTOM">CUSTOM</option>
                    <option value="REVIEW">REVIEW</option>
                    <option value="QUIZ">QUIZ</option>
                    <option value="LINK">LINK</option>
                    <option value="LUNICLEAN">LUNICLEAN</option>
                    <option value="LUNISHOWER">LUNISHOWER</option>
                    <option value="LIMEAT">LIMEAT</option>
                    <option value="PROOF">PROOF</option>
                  </>
                ) : (
                  <>
                    <option value="CODE">CODE</option>
                    <option value="EAU">EAU</option>
                    <option value="SLIDER">SLIDER</option>
                  </>
                )}
              </select>
            </div>
            {type === "rewards" && (
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Volume eau (si type EAU)</label>
                <input type="number" min="0" value={waterVolume} onChange={(e) => setWaterVolume(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" />
              </div>
            )}
            <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Description (FR)</label>
            <textarea value={descriptionFr} onChange={(e) => setDescriptionFr(e.target.value)} rows={3} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="Courte description" required />
            </div>
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description (EN)</label>
            <textarea value={descriptionEn} onChange={(e) => setDescriptionEn(e.target.value)} rows={3} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="Short description in English" />
            </div>
            <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Description (AR)</label>
            <textarea value={descriptionAr} onChange={(e) => setDescriptionAr(e.target.value)} rows={3} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="الوصف" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Sous-titre (FR)</label>
              <input value={subtitleFr} onChange={(e) => setSubtitleFr(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="Sous-titre de carte" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Sous-titre (EN)</label>
              <input value={subtitleEn} onChange={(e) => setSubtitleEn(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="Card subtitle" />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Sous-titre (AR)</label>
              <input value={subtitleAr} onChange={(e) => setSubtitleAr(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="العنوان الفرعي" />
            </div>
            <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">URL de l'image (optionnel)</label>
            <input value={imageUrl} onChange={(e) => setImageUrl(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="https://..." />
            </div>
            <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">URL de l'icône (optionnel)</label>
            <input value={iconUrl} onChange={(e) => setIconUrl(e.target.value)} className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-1 focus:ring-[#365644]" placeholder="https://..." />
            </div>
          </div>
          <div className="pt-2 flex items-center justify-end space-x-2">
            <button type="button" onClick={onClose} className="px-3 py-2 text-sm rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50">
              Annuler
            </button>
            <button type="submit" className="px-3 py-2 text-sm rounded-md bg-[#365644] text-white hover:bg-[#2d4a3a]">
              Enregistrer
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default QuickItemModal;
